import { SettingsPage } from '@/admin-design/_common/settings'
import { PageHeader } from '@/ui'

/** /settings: the server's own settings panels (what the manifest declares:
 *  groups, about) under the console's header. The panels are _common's and
 *  keep their own tabs; `?tab=<group key>` opens one (the attention list and
 *  the usage page link `?tab=tracking` and `?tab=analytics`).
 *
 *  _common prints its own "Settings" title and version badge first; the
 *  title is hidden so the page has one heading, the badge stays. */
export default function Settings() {
  return (
    <>
      <PageHeader title="설정" />
      <div className="[&_h1]:sr-only [&>div]:!max-w-none [&>div]:!p-0">
        <SettingsPage />
      </div>
    </>
  )
}
